export default __webpack_public_path__ + "static/media/queue.524ca411.svg";